$(document).ready(function () {
    var articleUrl = window.location.pathname.split("/").pop();
    if ($("#mi-blog-related-categories-list").length == 0) {
        showCategories(articleUrl);
    }

});

function showCategories(articleUrl) {
    var queryString = "?articleUrl=" + articleUrl + "&selectedItemId=" + $('#mi-corpo-blog-selectedItemId').val() + "&redirectPage=" + $('#mi-corpo-blog-redirectpage').val();
    var requestManager = new AsyncRequestManager();
    requestManager.renderAsyncRequest('/blogrelatedcategories/searchrelatedcategories', queryString, '[data-widget="elcablogrelatedcategories"]', true);
}	